import { useState } from "react";
import heroBanner from "../../assets/images/pages/florida-driving-test.jpg";
import ShellCard from "../../components/ShellCard.jsx";
import { faPhone, faCartShopping } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const DriverLicenseRoadTest = () => {
    const [selectedBundle, setSelectedBundle] = useState(0);
    const [selectedRoad, setSelectedRoad] = useState(0);
    const [showUpsellModal, setShowUpsellModal] = useState(false);

    const locations = [
        {
            title: "Miami-Dade Road Test Location",
            address: ["1321 SW 107 Avenue, 2nd Floor, #213A", "Miami, FL 33174"],
            directionsLink: "https://www.mapquest.com/us/florida/miami/33174-2521/1321-sw-107th-ave-25.75653,-80.36661",
            regId: "MQ=="
        },
        {
            title: "Miami-Dade Road Test Location",
            address: ["180 NW 183 Street, #113", "Miami, FL 33169"],
            directionsLink: "https://www.mapquest.com/us/florida/miami/33169/nw-183rd-st-25.9426,-80.20156",
            regId: "NA=="
        },
        {
            title: "Broward Road Test Location",
            address: ["3726 W. Oakland Park Blvd,", "Lauderdale Lakes, FL 33311"],
            directionsLink: "https://www.mapquest.com/us/florida/lauderdale-lakes/33311-1151/3726-w-oakland-park-blvd-26.16461,-80.19931",
            regId: "Mg=="
        },
        {
            title: "Palm Beach County Test Location",
            address: ["1993 S. Military Trail,", "West Palm Beach, FL 33415"],
            directionsLink: "https://www.mapquest.com/us/florida/west-palm-beach/33415-6405/1993-s-military-trl-26.64827,-80.11339",
            regId: "Mw=="
        }
    ];

    const getBundleLink = (index) => `https://classroom.metrotrafficschool.com/road-exam/registration/MzE=/${locations[index].regId}`;
    const getRoadTestLink = (index) => `https://classroom.metrotrafficschool.com/road-exam/registration/MTg=/${locations[index].regId}`;

    return (
        <>
            <section className="hero-slider-section">
                <div
                    className="hero-banner"
                    style={{
                        backgroundImage: `url(${heroBanner})`,
                    }}
                >
                    <div className="banner-text-container">
                        <div className="banner-heading">
                            <h1 className="banner-title">Driver License Road Test</h1>
                            <p className="banner-subheading">also referred to as Road Test</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="container mt-5">
                <div className="row mb-5">
                    <div className="col-12">
                        <ShellCard>
                            <div className="row mb-5">
                                <div className="col-12">
                                    <h3 className="fw-bold mb-4" style={{ color: "var(--metro-yellow)" }}>
                                        Benefits of Taking DMV Driving Test with Metro:
                                    </h3>
                                    <ul className="mb-4 lh-lg" style={{ color: "#fff", listStyleType: "none", paddingLeft: 0 }}>
                                        <li className="mb-2">
                                            <span className="me-2" style={{ color: "var(--metro-yellow)" }}>❯</span>
                                            Get in and out quickly
                                        </li>
                                        <li className="mb-2">
                                            <span className="me-2" style={{ color: "var(--metro-yellow)" }}>❯</span>
                                            Use our Dual Controlled car
                                        </li>
                                        <li className="mb-2">
                                            <span className="me-2" style={{ color: "var(--metro-yellow)" }}>❯</span>
                                            Low pressure environment
                                        </li>
                                        <li className="mb-2">
                                            <span className="me-2" style={{ color: "var(--metro-yellow)" }}>❯</span>
                                            Immediate reporting to DMV – Go pick up license as soon as you pass the driving test
                                        </li>
                                        <li className="mb-2">
                                            <span className="me-2" style={{ color: "var(--metro-yellow)" }}>❯</span>
                                            Offered at our convenient locations
                                        </li>
                                        <li className="mb-2">
                                            <span className="me-2" style={{ color: "var(--metro-yellow)" }}>❯</span>
                                            Receive a discount on the driving test if you also purchase any other related course from Metro
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div className="row mb-5">
                                <div className="col-12">
                                    <div className="p-4 rounded" style={{ backgroundColor: "#252525", borderLeft: "4px solid var(--metro-yellow)" }}>
                                        <p className="mb-0 lh-lg" style={{ color: "#fff" }}>
                                            For the purposes of obtaining a driver’s license, terms such as <strong>Road Test</strong>, <strong>Road Exam</strong>, <strong>Skills Test</strong>, <strong>Skills Exam</strong>, <strong>Class E Driving Exam</strong> are interchangeable and mean the same thing.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="row mb-5">
                                <div className="col-12 text-center">
                                    <h4 className="fw-bold mb-4" style={{ color: "#fff" }}>To enroll Click below OR Call us at</h4>

                                    <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-4 mb-4">
                                        <div className="d-flex flex-row gap-2">
                                            <a href="tel:305-553-5000" className="text-decoration-none fw-bold fs-5" style={{ color: "var(--metro-yellow)" }}>
                                                <FontAwesomeIcon icon={faPhone} className="me-2" />
                                                (305) 553-5000
                                            </a>
                                            <span className="fw-bold text-white fs-5">OR</span>
                                            <a href="tel:1-888-41-METRO" className="text-decoration-none fw-bold fs-5" style={{ color: "var(--metro-yellow)" }}>
                                                <FontAwesomeIcon icon={faPhone} className="me-2" />
                                                1-888-41-METRO
                                            </a>
                                        </div>
                                    </div>
                                    <div className="text-center">
                                        <p className="fst-italic" style={{ color: "#aaa", fontSize: "0.9rem" }}>
                                            * All who complete the DMV Test, outside of the DMV office are subject to random re-examination.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="row justify-content-center mb-5">
                                <div className="col-12 col-lg-6 mb-4 mb-lg-0">
                                    <div className="d-flex flex-column h-100 rounded" style={{ backgroundColor: "#252525", border: "1px solid #444" }}>
                                        <div className="p-3 text-center position-relative rounded-top d-flex flex-column justify-content-center" style={{ backgroundColor: "#2ecc71", color: "white", minHeight: "135px" }}>
                                            <span className="position-absolute top-0 start-50 translate-middle bg-white text-dark px-3 py-1 rounded-pill fw-bold shadow-sm" style={{ fontSize: "0.8rem" }}>Best Value</span>
                                            <h4 className="fw-bold mt-3 mb-1">Road Test Prep & Road Test</h4>
                                            <h5 className="fw-bold mb-0">(Bundle)</h5>
                                        </div>
                                        <div className="p-4 flex-grow-1 d-flex flex-column">
                                            <div className="text-center mb-4">
                                                <span className="display-3 fw-bold text-white">$150</span>
                                            </div>
                                            <ul className="list-unstyled mb-4 text-light">
                                                <li className="mb-2 py-2 border-bottom border-secondary">Pass the test on the first attempt.</li>
                                                <li className="mb-2 py-2 border-bottom border-secondary">Know what will be on the test.</li>
                                                <li className="mb-2 py-2 border-bottom border-secondary">Save the cost of paying for a retake.</li>
                                            </ul>

                                            <div className="mt-auto">
                                                <h5 className="fw-bold text-white mb-3">Select Your Location</h5>
                                                <div className="d-flex flex-column gap-2 mb-4">
                                                    {locations.map((loc, index) => (
                                                        <label key={index} className="d-flex align-items-start p-3 rounded" style={{ backgroundColor: "#333", cursor: "pointer", border: "1px solid #444" }}>
                                                            <input
                                                                type="radio"
                                                                name="bundleLocation"
                                                                className="mt-1 me-2"
                                                                checked={selectedBundle === index}
                                                                onChange={() => setSelectedBundle(index)}
                                                            />
                                                            <div>
                                                                <div className="fw-bold text-white" style={{ fontSize: "0.9rem" }}>{loc.title}</div>
                                                                <div className="text-muted" style={{ fontSize: "0.85rem" }}>{loc.address.join(" ")}</div>
                                                            </div>
                                                        </label>
                                                    ))}
                                                </div>
                                                <div className="text-center">
                                                    <a href={getBundleLink(selectedBundle)} className="btn fw-bold px-4 py-2 metro-btn-primary">Get Started</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-lg-6">
                                    <div className="d-flex flex-column h-100 rounded overflow-hidden" style={{ backgroundColor: "#252525", border: "1px solid #444" }}>
                                        <div className="p-4 text-center d-flex flex-column justify-content-center" style={{ backgroundColor: "var(--metro-yellow)", color: "#544312", minHeight: "135px" }}>
                                            <h4 className="fw-bold mb-0">Road Test</h4>
                                        </div>
                                        <div className="p-4 flex-grow-1 d-flex flex-column">
                                            <div className="text-center mb-4">
                                                <span className="display-3 fw-bold text-white">$100</span>
                                            </div>
                                            <ul className="list-unstyled mb-4 text-light">
                                                <li className="mb-2 py-2 border-bottom border-secondary">Fast and Easy – No waiting.</li>
                                                <li className="mb-2 py-2 border-bottom border-secondary">Use our car.</li>
                                                <li className="mb-2 py-2 border-bottom border-secondary">Immediate reporting to DMV.</li>
                                            </ul>

                                            <div className="mt-auto">
                                                <h5 className="fw-bold text-white mb-3">Select Your Location</h5>
                                                <div className="d-flex flex-column gap-2 mb-4">
                                                    {locations.map((loc, index) => (
                                                        <label key={index} className="d-flex align-items-start p-3 rounded" style={{ backgroundColor: "#333", cursor: "pointer", border: "1px solid #444" }}>
                                                            <input
                                                                type="radio"
                                                                name="roadTestLocation"
                                                                className="mt-1 me-2"
                                                                checked={selectedRoad === index}
                                                                onChange={() => setSelectedRoad(index)}
                                                            />
                                                            <div>
                                                                <div className="fw-bold text-white" style={{ fontSize: "0.9rem" }}>{loc.title}</div>
                                                                <div className="text-muted" style={{ fontSize: "0.85rem" }}>{loc.address.join(" ")}</div>
                                                            </div>
                                                        </label>
                                                    ))}
                                                </div>
                                                <div className="text-center">
                                                    <button
                                                        onClick={() => setShowUpsellModal(true)}
                                                        className="btn fw-bold px-4 py-2 metro-btn-secondary"
                                                    >
                                                        Get Started
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ShellCard>

                        <div className="row mt-5">
                            <div className="col-12 text-center mb-4">
                                <h2 className="fw-bold text-warning">Metro Testing Sites</h2>
                            </div>
                            {locations.map((loc, index) => (
                                <div key={index} className="col-12 col-md-6 col-lg-3">
                                    <div className="card h-100 border-0 shadow-sm" style={{ backgroundColor: "#252525", border: "1px solid #444" }}>
                                        <div className="card-body d-flex flex-column">
                                            <h5 className="card-title fw-bold text-white">{loc.title}</h5>
                                            <div className="mb-auto">
                                                {loc.address.map((line, i) => (
                                                    <p key={i} className="card-text mb-0 fst-italic text-light" style={{ opacity: 0.8 }}>{line}</p>
                                                ))}
                                            </div>
                                            <div className="mt-3">
                                                <a href={loc.directionsLink} target="_blank" rel="noopener noreferrer" className="text-decoration-none fw-bold text-warning">Directions</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {
                            showUpsellModal && (
                                <div
                                    className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                                    style={{ backgroundColor: "rgba(0,0,0,0.8)", zIndex: 1050 }}
                                    onClick={() => setShowUpsellModal(false)}
                                >
                                    <div
                                        className="rounded overflow-hidden shadow-lg position-relative"
                                        style={{ backgroundColor: "#252525", width: "95%", maxWidth: "500px", border: "1px solid #444" }}
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <div className="d-flex justify-content-between align-items-center p-3" style={{ backgroundColor: "var(--metro-yellow)", color: "#544312" }}>
                                            <h4 className="fw-bold m-0">Add Permit Prep Test</h4>
                                            <button
                                                onClick={() => setShowUpsellModal(false)}
                                                className="btn-close"
                                                aria-label="Close"
                                                style={{ filter: "brightness(0.5)" }}
                                            ></button>
                                        </div>
                                        <div className="p-4 text-white">
                                            <ul className="mb-4 text-light">
                                                <li className="mb-2">Pass the test on the first attempt.</li>
                                                <li className="mb-2">Know what will be on the test.</li>
                                                <li className="mb-2">Save the cost of paying for a retake.</li>
                                            </ul>

                                            <div className="p-3 rounded mb-4 shadow-sm" style={{ backgroundColor: "#333", border: "1px solid #444" }}>
                                                <p className="fw-bold mb-1 text-warning">Note :</p>
                                                <p className="mb-0 text-white">We offers the Road Test Prep (30 minutes ) along with your Road test, Do you want to add this ?</p>
                                            </div>

                                            <div className="d-flex justify-content-end gap-3 align-items-center mt-4">
                                                <a
                                                    href={getRoadTestLink(selectedRoad)}
                                                    className="text-white text-decoration-underline"
                                                >
                                                    No Thanks
                                                </a>
                                                <a
                                                    href={getBundleLink(selectedRoad)}
                                                    className="btn fw-bold px-3 py-2"
                                                    style={{ backgroundColor: "#2ecc71", color: "white", fontSize: "0.8rem" }}
                                                >
                                                    <FontAwesomeIcon icon={faCartShopping} className="me-2" />
                                                    Add to Cart
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            </section >
        </>
    );
};

export default DriverLicenseRoadTest;
